module.exports = __webpack_public_path__ + "img/p114.55817641.jpg";